



















































import { search } from '@adobe/edex/frontend/api/search';
import { createEnrollee } from '@adobe/edex/frontend/api/course';
import { debounce } from 'lodash-es';

export default {
  name: 'enroll-member',
  props: {
    courseID: {
      required: true,
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      filter: '',
      selected: '',
      searchResults: [],
      searchTimeout: undefined,
      loading: false,
      error: false,
    };
  },
  created() {
    this.onAuthorSearch = debounce(this.onAuthorSearch, 300);
  },
  methods: {
    async onAuthorSearch() {
      if (this.filter.length < 3) {
        return;
      }
      const { data } = await search({
        params: {
          r: 'members',
          q: this.filter,
        },
      });
      this.searchResults = data.data;
    },
    async submit() {
      this.loading = true;

      try {
        const { data } = await createEnrollee(this.courseID, {
          memberID: this.selected,
        });
        if (data) {
          this.$emit('onEnrollmentCreated');
          this.filter = '';
          this.selected = '';
          this.searchResults = [];
          this.searchTimeout = undefined;
          this.error = false;
        }
      } catch (error) {
        this.$emit('onEnrollmentCreatedError');
        this.error = true;
      }

      this.loading = false;
    },
  },
};
